import { axiosInstance } from '../instance'

export const clickCollectInstance = new axiosInstance(
  `${process.env.REACT_APP_API_ENDPOINT}/clickcollect`
)
